import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Person } from '../../../models/person';
import { faPlus }  from '@fortawesome/fontawesome-pro-regular';
import { faUser } from '@fortawesome/pro-solid-svg-icons'
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';


@Component({
  standalone: false,
  selector: 'app-modal-choose-person',
  templateUrl: './modal-choose-person.component.html',
styleUrls:  ['./modal-choose-person.component.css']
})
export class ModalChoosePersonComponent extends SmsAbstractAppPage implements OnInit {

  role: string = "";
  faPlus = faPlus;
  faUser = faUser;

  allowAddNew: boolean = true;

  @Output() person_selected$: EventEmitter<Person> = new EventEmitter<Person>();
  @Output() add_new_selected$: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit() {
  }

  handlePersonSelection(person: Person){
  	this.person_selected$.emit(person);
  }

  handleAddNew(){
  	this.add_new_selected$.emit(true);
  }

  public setAllowAddNew(allow: boolean){
    this.allowAddNew = allow;
  }

}
